<template lang="pug">
.deal-theme.mb-S
  h2.mb-S Themes
  .checkboxes
    .checkbox(v-for="(theme, i) in businessUnit.Theme" :key="i")
      label
        input(
          type="checkbox"
          name="Theme[]"
          :value="theme.slug"
          :checked="dealHasTheme(theme.slug)"
          @input="event => setDealTheme(theme.slug, event.target.checked)"
          )
        span.icon-span
          BriqIcon(name="icon-input-checkbox-icon" :customStyle="{color: 'white'}")
        | {{ theme.name }}
        span.optional-marker Optional
</template>

<script>
// todo: add disabled prop when saving
export default {
  name: 'DealTheme',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    businessUnit: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dealHasTheme(slug) {
      if (!slug) return false
      const array = this.deal.Theme || []
      return array?.includes(slug)
    },
    setDealTheme(slug, enable) {
      if (enable && !this.dealHasTheme(slug)) {
        if (!this.deal.Theme) this.deal.Theme = []
        this.deal.Theme.push(slug)
      }
      if (!enable && this.dealHasTheme(slug)) {
        this.deal.Theme = this.deal.Theme.filter(n => n !== slug)
      }
    },
  },
}
</script>

<style scoped lang="stylus">
// todo: refactor with BriqCheckbox
.deal-theme
  .checkbox input:checked + .icon-span
    background #00aaff
    border-color #00aaff

  .checkboxes
    background transparent
    padding 7px
    border none

  .checkboxes.disabled
    label
      cursor not-allowed
      opacity .5

    .checkbox input:checked + .icon-span
      background #4e5a6a
      border-color #4e5a6a
</style>
